<div [ngClass]="{ label: true, required: required }">{{ label }}</div>
<ng-content></ng-content>
